module.exports = __webpack_public_path__ + "h5/img/wx.b92c7d3f.png";